export default __webpack_public_path__ + "static/media/voicefriend-icon-logo.518eec58.png";